// extracted by mini-css-extract-plugin
export default {"btns":"admin_btns__Ldrx4","head":"admin_head__qxpnC"};